import { Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekCheckbox = styled(Checkbox)(({ theme }) => ({
    color: theme.palette.grey[300],
    width: "unset !important",
}));

export { PeekCheckbox, PeekCheckbox as default };
